module.exports = "//s1.igetcool.com/mall-h5/img/icon_default_avatar.cdfd6a83.png";